import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { PrimaryButton } from "../button/primary.button";

export function PdfExporter(params: {
    targetRef: any,
    licenseNumber: number
}) {


    const handleDownloadPdf = () => {
        const input = params.targetRef.current;
        html2canvas(input).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");

            // Credit card dimensions in mm
            const cardWidth = input.offsetWidth;
            const cardHeight = input.offsetHeight;

            // Initialize jsPDF with card dimensions
            const pdf = new jsPDF({
                orientation: "portrait", // Landscape for wider width
                unit: "px",
                format: [cardWidth, cardHeight],
            });

            // Calculate the aspect ratio to maintain the content's integrity
            const imgWidth = cardWidth;
            const imgHeight = cardHeight;

            // Add the image to the PDF
            pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

            // Save the PDF
            pdf.save(`licence${params.licenseNumber}.pdf`);
        });
    };

    return (
        <PrimaryButton icon={"download"} onClick={handleDownloadPdf} variant="warning" type="button">
            Download AS PDF
        </PrimaryButton>
    );
};

// -- A4 SIZE --
//const handleDownloadPdf = () => {
//    const input = params.targetRef.current;
//    html2canvas(input).then((canvas) => {
//        const imgData = canvas.toDataURL("image/png");
//        const pdf = new jsPDF("p", "mm", "a4");

//        const imgWidth = 210; // A4 width in mm
//        const imgHeight = (canvas.height * imgWidth) / canvas.width;

//        pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
//        pdf.save(`licence${params.licenseNumber}.pdf`);
//    });
//};